import React from "react";
import ProductFilter from "./ProductFilter";
import ProductList from "./ProductList";

const ProductPageComponent = () => {

    // Render the product page layout
    return (
        <div className="lg:flex flex-1 overflow-hidden bg-light pt-28">
            {/* Product Filter on the left */}
            <div className="lg:w-1/4 lg:h-full sm:w-full overflow-y-auto p-4 custom-scrollbar">
                <ProductFilter />
            </div>
            {/* Product List on the right */}
            <div className="w-full h-full overflow-y-auto bg-gray-100 p-4 custom-scrollbar">
                <ProductList />
            </div>
        </div>
    );
};

export default ProductPageComponent;
